"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ExtEndpointModule_1 = __importDefault(require("../../ext/ExtEndpointModule"));
var CommonExtWebPopupEndpointModule = /** @class */ (function (_super) {
    __extends(CommonExtWebPopupEndpointModule, _super);
    function CommonExtWebPopupEndpointModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommonExtWebPopupEndpointModule.prototype.initEndpoint = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.statusNotice = function (extTypeIconInfo, adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.textNotice = function (tips, adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.postInit = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.showEndpointPanel = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.hideEndpointPanel = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.showEndpointEntrance = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.hideEndpointEntrance = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.ready = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.showSupError = function (msg, adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.getModalContainer = function (adapter) {
        throw new Error("Method not implemented.");
    };
    CommonExtWebPopupEndpointModule.prototype.close = function (content, adapter) {
        throw new Error("Method not implemented.");
    };
    return CommonExtWebPopupEndpointModule;
}(ExtEndpointModule_1["default"]));
exports["default"] = CommonExtWebPopupEndpointModule;
